import { useAtomValue } from 'jotai';
import { reviewsAtom } from '../../atoms';

export const useAgencyReviews = () => useAtomValue(reviewsAtom);
